import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const Popup = ({ children, trigger, placement, show }) => (
  <OverlayTrigger
    rootClose
    show={show}
    placement={placement ? placement : 'auto'}
    delay={{ show: 0, hide: 0 }}
    trigger={['click']}
    overlay={
      <Popover id={`base-popup`} className="base-popup">
        {children}
      </Popover>
    }
  >
    {trigger}
  </OverlayTrigger>
);

Popup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  trigger: PropTypes.node,
  placement: PropTypes.string,
  show: PropTypes.bool,
};

export default Popup;
